// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MroJ","right":"styles_right__21XPf"};